import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/saude/conferencia/listar/form_status'
import Head from '../../../../../components/head'


function EditarSaudeScreen () {
    return (
        <Fragment>
            <Head titulo="Validando Inscrição" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarSaudeScreen;